import './App.css';

import { ModalProvider } from 'react-modal-hook';
import { BrowserRouter as Router, Redirect, Route, Switch } from 'react-router-dom';

import { Announcements, Navbar, ProtectedRoute, View } from './components';
import { Admin, Forms, StepInstance, Tracks, Users } from './pages';
import {
  AuthenticatedAbilityProvider,
  AuthenticationProvider,
  RoleProvider,
  useAuthenticatedUserAbility
} from './providers';

// Roles without track access (e.g. Agency Staff) land on the Users table instead of a page that
// would only refuse them.
function Home() {
  const ability = useAuthenticatedUserAbility();

  return <Redirect to={ability.can('read', 'TrackTemplate') ? '/tracks' : '/users'} />;
}

function App() {
  return (
    <Router>
      <AuthenticationProvider>
        <AuthenticatedAbilityProvider>
          <RoleProvider>
            <ModalProvider>
              <View className="App">
                <Switch>
                  <Route path="/">
                    <Navbar />
                    <Announcements />
                    <Switch>
                      <Route exact path="/" component={Home} />
                      <Route path="/tracks" component={Tracks} />

                      {/* TODO: Add permission check for step instance access
                          Example: Check if user has access to the specific step instance
                          hasPermission={(ability) => ability.can('read', 'StepInstance')} */}
                      <ProtectedRoute path="/step/:id">
                        <StepInstance />
                      </ProtectedRoute>

                      {/* TODO: Add permission check for admin routes
                          Example: Check if user has admin/conference management permissions
                          hasPermission={(ability) => ability.can('read', 'Conference')} */}
                      <ProtectedRoute path="/admin">
                        <Admin />
                      </ProtectedRoute>

                      {/* TODO: Add permission check for user routes
                          Example: Check if user has permission to view user profiles
                          hasPermission={(ability) => ability.can('read', 'User')} */}
                      <ProtectedRoute path="/users">
                        <Users />
                      </ProtectedRoute>

                      {/* TODO: Add permission check for form routes
                          Example: Check if user has permission to manage forms
                          hasPermission={(ability) => ability.can('read', 'FormTemplate')} */}
                      <ProtectedRoute path="/forms">
                        <Forms />
                      </ProtectedRoute>
                    </Switch>
                  </Route>
                </Switch>
              </View>
              <div id="modals" />
            </ModalProvider>
          </RoleProvider>
        </AuthenticatedAbilityProvider>
      </AuthenticationProvider>
    </Router>
  );
}

export default App;
